module.exports = __webpack_public_path__ + "img/royal hospitals indoor shoot-4.31a6eb39.webp";